/* global swal */
import { isEqual } from 'lodash';

export default function($log, Swal, $state, ApiClass) {
  'ngInject';

  const vm = this;
  vm.$onChanges = activate;

  vm.selected = 0;

  vm.onFilter = function(stCtrl) {
    const oldFiltered = (vm.filtered || []).map(({ email }) => email);
    const newFiltered = stCtrl.getFilteredCollection().map(({ email }) => email);
    if (!isEqual(oldFiltered, newFiltered)) vm.selectAllEmployees = false;
    vm.filtered = stCtrl.getFilteredCollection();
  };

  vm.register = registrant => {
    Swal.confirm('Registration?', `Register ${registrant.email} for this event.`)
      .then(() => vm.addRegistrants({ data: [registrant], suppress: !registrant.sendEmail }))
      .then(() => {
        $state.reload();
      })
      .catch(error => {
        if (error.dismiss) return;
        Swal.toast('Error with registration', 'error');
        $log.error(error);
        throw error;
      });
  };

  vm.registerMultiple = () => {
    const selected = vm.waitlist.filter(user => user.selected);
    Swal.confirm('Registration?', `Register ${vm.selected} user(s) for this event.`)
      .then(() => vm.addRegistrants({ data: selected, suppress: !!vm.suppress }))
      .then(() => {
        $state.reload();
      })
      .catch(error => {
        if (error.dismiss) return;
        Swal.toast('Error with registrations', 'error');
        $log.error(error);
        throw error;
      });
  };

  vm.changeWaitlist = () => {
    const locations = [vm.event.delivery_location, ...vm.event.locations.map(({ location }) => location)]
      .filter(location => location !== vm.location.location)
      .reduce((obj, item) => {
        obj[item] = item;
        return obj;
      }, {});

    const profile_uids = vm.waitlist.filter(user => user.selected).map(({ profile_uid }) => profile_uid);

    return swal({
      title: 'Change Waitlist Registration',
      input: 'select',
      inputOptions: locations,
      inputPlaceholder: 'Select location',
      showCancelButton: true
    })
      .then(({ value: location }) => {
        if (!location) throw new Error('No Location provided');
        return ApiClass.eventsIdTypePatch(
          { id: vm.event.event_id, type: 'waitlistAttendees' },
          { profile_uids, location },
          { queryParams: { manage: true } }
        );
      })
      .then(() => {
        Swal.toast('Waitlist registrations changed');
        $state.reload();
      })
      .catch(error => {
        if (error.dismiss) return;
        if (error.status === 409)
          return Swal.alert('Error', 'Waitlist registrant(s) have already been removed from the event.', 'info');
        Swal.toast('Error moving waitlist registration', 'error');
        $log.error(error);
        throw error;
      });
  };

  vm.deleteWaitlist = () => {
    const profile_uids = vm.waitlist.filter(user => user.selected).map(({ profile_uid }) => profile_uid);
    return Swal.confirm('Revoke Registrations?', `Revoke ${vm.selected} waitlist registrations for this event.`)
      .then(() => {
        return ApiClass.eventsIdTypeDelete(
          { id: vm.event.event_id, type: 'waitlistAttendees' },
          { profile_uids },
          { queryParams: { manage: true } }
        );
      })
      .then(() => {
        vm.eventRegistrants = vm.waitlist.filter(({ selected }) => !selected);
        vm.selected = 0;
        $state.reload();
        Swal.toast('Revoked waitlist registrations');
      })
      .catch(error => {
        if (error.dismiss) return;
        Swal.toast('Error revoking waitlist registratios', 'error');
        $log.error(error);
        throw error;
      });
  };

  vm.selectAll = () => {
    vm.filtered.forEach(user => (user.selected = vm.selectAllModel));
    vm.updateSelected();
  };

  vm.updateSelected = () => (vm.selected = vm.waitlist.filter(user => user.selected).length);

  function activate() {
    if (!vm.location) return;
    vm.loaded = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/admin/eventManager/event/waitlist/controller.js